export function getBurnoutRisk(member) {
  const classification = member?.classification === 'worker' ? 'worker' : 'staff';
  const avgHours = member?.avg_daily_effective_hours ?? 0;
  const extendedRate = member?.extended_days_rate ?? 0;
  const consecutiveDays = member?.consecutive_working_days ?? 0;

  if (consecutiveDays >= 12) return 'red';

  if (classification === 'staff') {
    if (avgHours >= 10 || extendedRate >= 0.7) return 'red';
    if (avgHours >= 9 || extendedRate >= 0.5) return 'amber';
    return 'green';
  }

  if (avgHours >= 11) return 'red';
  if (avgHours >= 10) return 'amber';
  return 'green';
}

export function getBurnoutRiskMeta(level) {
  switch (level) {
    case 'red':
      return {
        label: 'High',
        dot: 'bg-red-500',
        pill: 'bg-red-50 text-red-700 ring-red-600/20',
        text: 'text-red-700',
        bar: 'bg-red-500',
      };
    case 'amber':
      return {
        label: 'Watch',
        dot: 'bg-amber-500',
        pill: 'bg-amber-50 text-amber-700 ring-amber-600/20',
        text: 'text-amber-700',
        bar: 'bg-amber-500',
      };
    default:
      return {
        label: 'Stable',
        dot: 'bg-green-500',
        pill: 'bg-green-50 text-green-700 ring-green-600/20',
        text: 'text-green-700',
        bar: 'bg-green-500',
      };
  }
}

export function getBurnoutPriorityScore(member) {
  const risk = getBurnoutRisk(member);
  const avgHours = member?.avg_daily_effective_hours ?? 0;
  const extendedRate = member?.extended_days_rate ?? 0;
  const consecutiveDays = member?.consecutive_working_days ?? 0;
  const riskBase = risk === 'red' ? 200 : risk === 'amber' ? 100 : 0;

  return riskBase + (consecutiveDays * 5) + (avgHours * 3) + (extendedRate * 100);
}
